import React from "react";
import { useDispatch } from "react-redux";
import { Formik, Field, Form } from "formik";
import { useTranslation } from "react-i18next";
import { onPasswordUpdate } from "../../../store/Settings/actions";
import { ToastContainer, Flip } from 'react-toastify';
import * as yup from "yup";
import 'react-toastify/dist/ReactToastify.css';

export const PasswordUpdate = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    
    const handleSubmit = async (values, {resetForm}) => {
        dispatch(onPasswordUpdate(values));                      
        resetForm();
    }
   
    const passwordValidationSchema = yup.object().shape({
        password: yup.string().required(t("Required")),
        new_password: yup
            .string()
            .matches(
                "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^ws]).{8,}$",
                "Must Contain 8 Characters, One Uppercase, One Lowercase and One Number "
            )
            .required(t("Required")),
        confirm_password: yup
            .string()
            .required(t("Please confirm your password"))
            .oneOf([yup.ref("new_password")], t("Passwords do not match")),
    });

    return (
        <div className="rounded-lg shadow-md bg-white pt-5 pr-12 pb-4 pl-5">
            <Formik
                enableReinitialize
                initialValues={{
                    password: "",
                    new_password: "",
                    confirm_password: "",
                }}
                onSubmit={handleSubmit}
                validationSchema={passwordValidationSchema}
            >
                {({ errors, touched }) => (
                    <Form>
                        <p className="font-bold text-base">
                            {t("Update Password")}
                        </p>
                        <span className="text-xs text-gray-600">
                            {t("Ensure your account is safe with a secure password")}
                        </span>

                        <div className="col-span-3 sm:col-span-3 py-3.5">
                            <label
                                htmlFor="password"
                                className="block text-xs font-semibold"
                            >
                                {t("Current Password")}
                            </label>
                            <Field
                                type="password"
                                name="password"
                                placeholder={t("Current password")}
                                className="input mt-1 border-none focus:ring-gray-200  focus:border-gray-100 bg-gray-50 block w-full shadow-sm sm:text-sm rounded-md"
                            />
                            {errors.password &&
                                touched.password && (
                                    <div className="text-red-500 text-sm mt-1 ml-2">
                                        {errors.password}
                                    </div>
                                )}
                        </div>

                        <div className="col-span-3 sm:col-span-3 py-3.5">
                            <label
                                htmlFor="new_password"
                                className="block text-xs font-semibold"
                            >
                                {t("New Password")}
                            </label>
                            <Field
                                type="password"
                                name="new_password"
                                placeholder={t("New password")}
                                className="input mt-1 border-none focus:ring-gray-200  focus:border-gray-100 bg-gray-50 block w-full shadow-sm sm:text-sm rounded-md"
                            />
                            {errors.new_password &&
                                touched.new_password && (
                                    <div className="text-red-500 text-sm mt-1 ml-2">
                                        {errors.new_password}
                                    </div>
                                )}
                        </div>

                        <div className="col-span-3 sm:col-span-3 py-3.5">
                            <label
                                htmlFor="confirm_password"
                                className="block text-xs font-semibold"
                            >
                                {t("Confirm Password")}
                            </label>
                            <Field
                                type="password"
                                name="confirm_password"
                                placeholder={t("Confirm password")}
                                className="input mt-1 border-none focus:ring-gray-200  focus:border-gray-100 bg-gray-50 block w-full shadow-sm sm:text-sm rounded-md"
                            />
                            {errors.confirm_password &&
                                touched.confirm_password && (
                                    <div className="text-red-500 text-sm mt-1 ml-2">
                                        {errors.confirm_password}
                                    </div>
                                )}
                        </div>

                        <div className="py-3 text-right">                                
                            <button
                                type="submit"
                                className="inline-flex justify-center py-2 px-7 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-900 hover:bg-gray-700 activ:bg-gray-800 focus:outline-none"
                            >
                                {t("Update")}
                            </button>
                            <ToastContainer transition={Flip}/>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};
